module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_01.1067d1b8.png";